// extracted by mini-css-extract-plugin
export default {"uploaded-by-text":"ieP4NNDoqY5T3fDjhgR8","purl":"QIQImkXVh4kapzF4IOKn"};